import React from 'react';
import { motion } from 'framer-motion';

import sass from "../assets/img/sass-color.svg";
import css from "../assets/img/css3-color.svg";
import firebase from "../assets/img/firebase-color.svg";
import framer from "../assets/img/framer-color.svg";
import git from "../assets/img/git-color.svg";
import html from "../assets/img/html5-color.svg";
import java from "../assets/img/javascript-color.svg";
import supabase from "../assets/img/supabase-color.svg";
import tailwind from "../assets/img/tailwindcss-color.svg";
import react from "../assets/img/react-color.svg";
import bootstrap from "../assets/img/bootstrap-color.svg";

const cdnIcon = (slug, hex) => `https://cdn.simpleicons.org/${slug}/${hex}`;

export const ScrollingIcons = () => {
    const icons = [
        { src: html,                              name: "HTML5" },
        { src: css,                               name: "CSS3" },
        { src: sass,                              name: "Sass" },
        { src: java,                              name: "JavaScript" },
        { src: cdnIcon("typescript", "3178C6"),   name: "TypeScript" },
        { src: react,                             name: "React" },
        { src: cdnIcon("nextdotjs", "ffffff"),    name: "Next.js" },
        { src: bootstrap,                         name: "Bootstrap" },
        { src: tailwind,                          name: "Tailwind" },
        { src: cdnIcon("nodedotjs", "339933"),    name: "Node.js" },
        { src: firebase,                          name: "Firebase" },
        { src: supabase,                          name: "Supabase" },
        { src: cdnIcon("mongodb", "47A248"),      name: "MongoDB" },
        { src: cdnIcon("figma", "F24E1E"),        name: "Figma" },
        { src: cdnIcon("vite", "646CFF"),         name: "Vite" },
        { src: git,                               name: "Git" },
        { src: framer,                            name: "Framer Motion" },
        { src: cdnIcon("wordpress", "21759B"),    name: "WordPress" },
    ];

    return (
        <div className="icon-container">
            <motion.div
                className="icon-track"
                animate={{ x: ["0%", "-50%"] }}
                transition={{
                    repeat: Infinity,
                    duration: 40,
                    ease: "linear",
                }}
            >
                {[...icons, ...icons].map((icon, index) => (
                    <div className="icon-wrapper" key={index}>
                        <img src={icon.src} alt={icon.name} className="icon" />
                        <p className="icon-name">{icon.name}</p>
                    </div>
                ))}
            </motion.div>
        </div>
    );
};
